import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import queryString from 'qs'

import LocationInterface from '../../interfaces/client/Location'
import ReduxStoreInterface from '../../interfaces/client/ReduxStore'
import FlightInterface from '../../interfaces/client/Flight'

import { closeCSVUpload } from '../../actions/modals'
import { requestFlight } from '../../actions/flights'
import { v1requestSSRList } from '../../actions/ssrs'

import { isTOFlight } from '../../utils/checkIsTOFlight'
import {
  getSmallestEconomyClassAllotmentCountFactory,
  getSmallestSmartClassAllotmentCountFactory,
} from '../../utils/travelClassSeatCount'

import NewBooking from '../../components/NewBooking'

interface NewBookingPropsInterface {
  location: LocationInterface
}

export const mapStateToProps = (
  state: ReduxStoreInterface,
  props: NewBookingPropsInterface
) => {
  const query = queryString.parse(props.location.search, {
    ignoreQueryPrefix: true,
  })
  const departureFlightId = query.departure as string
  const returnFlightId = query.return as string

  const departureFlight: FlightInterface = state.flights.byId[departureFlightId]
  const returnFlight: FlightInterface = state.flights.byId[returnFlightId]

  const economyClassAllotment =
    getSmallestEconomyClassAllotmentCountFactory(
      departureFlight,
      returnFlight
    ) || 0
  const smartClassAllotment =
    getSmallestSmartClassAllotmentCountFactory(departureFlight, returnFlight) ||
    0

  const areFlightsLoaded = () =>
    departureFlightId && returnFlightId
      ? state.flights.allIds.includes(departureFlightId) &&
        state.flights.allIds.includes(returnFlightId) &&
        !state.requests.isFetchingFlights.includes(departureFlightId) &&
        !state.requests.isFetchingFlights.includes(returnFlightId)
      : state.flights.allIds.includes(departureFlightId) &&
        !state.requests.isFetchingFlights.includes(departureFlightId)

  return {
    flightsAreLoaded: areFlightsLoaded(),
    departureFlightId,
    returnFlightId,
    smartClassAllotmentCount: smartClassAllotment,
    economyClassAllotmentCount: economyClassAllotment,
    isTOFlight: isTOFlight(departureFlightId),
    isSpecialSSRModalOpen: state.modals.isSpecialSSRModalOpen,
    isCSVUploadModalOpen: state.modals.isCSVUploadModalOpen,
    noAllotmentCount: !smartClassAllotment && !economyClassAllotment,
  }
}

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  requestSSRs: (flightId: string) => {
    dispatch(v1requestSSRList(flightId))
  },
  requestFlight: (flightId: string) => {
    dispatch(requestFlight(flightId))
  },
  closeCSVUpload: () => {
    dispatch(closeCSVUpload())
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NewBooking)
